/** Menyu va tugmalar uchun kichik amallar: nusxalash, yangi tabda ochish, qo'ng'iroq. */
import i18n from "i18next";
import { toast } from "@/components/ui/toast";

export async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(i18n.t("menu:copied"), text.length <= 80 ? text : undefined);
  } catch {
    toast.error(i18n.t("menu:copyFailed"));
  }
}

export function absoluteUrl(path: string): string {
  return new URL(path, window.location.origin).toString();
}

export function openInNewTab(path: string): void {
  window.open(absoluteUrl(path), "_blank", "noopener,noreferrer");
}

/** tel: havola -- kompyuterda softphone (Zoom, RingCentral...) ochiladi */
export function callPhone(phone: string): void {
  window.location.href = `tel:${phone.replace(/[^\d+]/g, "")}`;
}

export function sendEmail(email: string): void {
  window.location.href = `mailto:${email}`;
}
